import React from "react";
import "./style.css";

const HamburgerMenu = ({ isOpen, setIsOpen }) => {
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const menuClass = isOpen ? "hamburger-menu active" : "hamburger-menu";

  return (
    <div className={menuClass} onClick={handleClick}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default HamburgerMenu;
